import { currency } from 'mostra';
const {
  formatJP,
} = currency;
export {
  formatJP,
};
// const formmter = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' });
// export const formatJP = (currency: number): string => formmter.format(currency);
// export const dummy = () => null;
